import {
    Box,
    Button,
    Heading,
    Spinner,
    Text,
    Textarea,
    VStack
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { addTransactionNote, fetchTransactionById } from '../../api';
import { hasPermission } from '../../Utils';

export default function TransactionNotes({ transactionId }) {
    const [transaction, setTransaction] = useState(null);
    const [noteText, setNoteText] = useState('');
    const [addingNote, setAddingNote] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const load = async () => {
            const res = await fetchTransactionById(transactionId);
            if (res.success) setTransaction(res.data);
            setLoading(false);
        };
        load();
    }, [transactionId]);

    const handleAddNote = async () => {
        if (!noteText.trim()) return;
        setAddingNote(true);
        const res = await addTransactionNote(transactionId, noteText.trim());
        if (res.success) {
            const updated = await fetchTransactionById(transactionId);
            if (updated.success) setTransaction(updated.data);
            setNoteText('');
        }
        setAddingNote(false);
    };

    if (loading) return <Spinner mt={6} />;

    return (
        <Box p={6} mt={8} borderWidth="1px" borderRadius="lg">
            <Heading size="md" mb={4}>Notes</Heading>

            {transaction.notes?.length > 0 ? (
                <VStack align="start" spacing={4} mb={4}>
                    {transaction.notes.map((note, i) => (
                        <Box key={i} p={3} bg="gray.300" w="100%" borderRadius="md">
                            <Text mb={4} fontSize="sm">{note.text}</Text>
                            <Text fontSize="xs" color="gray.500">
                                {new Date(note.createdAt).toLocaleString()} - {note?.createdBy?.firstName + " " + note?.createdBy?.lastName}
                            </Text>
                        </Box>
                    ))}
                </VStack>
            ) : (
                <Text mb={5}>No notes yet.</Text>
            )}

            {hasPermission('addTransactionNote') &&
                <>
                    <Textarea
                        placeholder="Add a note..."
                        value={noteText}
                        onChange={(e) => setNoteText(e.target.value)}
                        mb={3}
                    />
                    <Button colorScheme="blue" onClick={handleAddNote} isLoading={addingNote}>
                        Add Note
                    </Button>
                </>
            }
        </Box>
    );
}
